import { css } from '@emotion/css';
import { Checkbox, Text } from 'Shared/forms/Inputs'
import { LabelOnRightWrap, Wrap } from 'Shared/forms/Wrap'
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { IntegratedSelectorAndComponent } from 'Shared/backend/widgets/IntegratedSelectorAndComponent';
import { LinkLayout } from 'Shared/model/Components';


export function LinkBlock(P:LinkLayout)
{
	const options = optionList([],['popup']);

	const detailsStyle = css({
		display: 'flex',
		flexDirection: 'column',
		gap: '0.8em',
	});

	return (
		<div class={detailsStyle}>
			<Wrap label='Link'>
				<Text field='link' placeholder='eg https://webaddress | page title for your own site eg /contact'/>
			</Wrap>

			<LabelOnRightWrap label='Open link on the same window'>
				<Checkbox field='openInSameWindow' />
			</LabelOnRightWrap>

			<IntegratedSelectorAndComponent {...P.content} label='Component' contentFieldName='content' options={options} required />
		</div>
	);
}

